import React, { useReducer } from 'react';
import PaymentAction from './paymentAction';
import paymentReducer from './paymentReducer';
import { charge } from '../../libs/snap/snapApi';
import { PaymentContext } from './paymentContext';
import Transaction from '../../models/transaction';
import { items } from '../../libs/data/item';
import { SNAP_CONTAINER } from '../../libs/data/consants';

export const paymentInitialState = {
  transaction: new Transaction(items),
  isLoading: false,
  isSuccessful: false,
  isError: false,
  isSubmitted: false,
};

const PaymentState = (props) => {
  const [state, dispatch] = useReducer(paymentReducer, paymentInitialState);

  const chargeTransaction = async (transaction) => {
    dispatch({ type: PaymentAction.SUBMIT_TRANSACTION });
    dispatch({ type: PaymentAction.GET_TOKEN_LOADING });
    await charge(transaction.toJSON())
      .then(({ token }) => {
        dispatch({ type: PaymentAction.GET_TOKEN_LOADED });
        window.snap.embed(token, {
          embedId: SNAP_CONTAINER,
          onSuccess: (_) => dispatch({ type: PaymentAction.PAYMENT_SUCCESS }),
          onError: (_) => dispatch({ type: PaymentAction.PAYMENT_FAILED })
        });
      })
      .catch((_) => dispatch({ type: PaymentAction.PAYMENT_FAILED }));
  };

  const resetTransaction = () => {
    dispatch({ type: PaymentAction.RESET_TRANSACTION });
  };

  return (
    <PaymentContext.Provider
      value={{
        ...state,
        chargeTransaction,
        resetTransaction
      }}
    >
      {props.children}
    </PaymentContext.Provider>
  );
};

export default PaymentState;
